import { defineNuxtPlugin } from '#app/nuxt'
import { LazySbAnimatedCounter, LazySbAudioPlayer, LazySbAudioPlayerNew, LazySbBoxWrapper, LazySbBreadcrumbs, LazySbChartBars, LazySbCircleProgressBar, LazySbCsSummary, LazySbCsSummaryItem, LazySbEventsSection, LazySbExpertCard, LazySbFadeCard, LazySbFeatureCard, LazySbFeatureCardLink, LazySbFilter, LazySbGlobalReachGlobe, LazySbGridTwoColumns, LazySbHiddenSection, LazySbHomepageGlobalReach, LazySbIcon, LazySbIframeVideo, LazySbImageCtaWhitePaper, LazySbImageWithLabels, LazySbInfiniteMarquee, LazySbInfoDepracationSection, LazySbInlineVideoPlayer, LazySbInsightsWhitePaper, LazySbLeader, LazySbLearnMore, LazySbLegalItem, LazySbLegalSection, LazySbLink, LazySbLinkWithImage, LazySbListItem, LazySbListItemRichtext, LazySbLogotypes, LazySbMarqueeGeneral, LazySbMobileSlider, LazySbNews, LazySbNewsroomFeaturedArticle, LazySbOverlayLabel, LazySbPatientStoryCard, LazySbPicture, LazySbPictureCardImage, LazySbPictureGraph, LazySbPictureGridImage, LazySbPictureIcon, LazySbPill, LazySbPortraitsRow, LazySbPostCard, LazySbQuoteAuthor, LazySbQuoteAuthorNarrow, LazySbQuotemarkText, LazySbRectangleLink, LazySbResearchStudy, LazySbResourcesHubNav, LazySbReversedPostCard, LazySbRichtext, LazySbRoiCalculator, LazySbSection, LazySbSectionAnimatedScroll, LazySbSectionGradient, LazySbSeparator, LazySbSimpleText, LazySbSimpleTwoColumns, LazySbSpacing, LazySbSpacingResponsive, LazySbStickyItems, LazySbTable, LazySbTag, LazySbTagsGroup, LazySbTestCaseTable, LazySbTestimonial, LazySbTextList, LazySbTextWithIcon, LazySbTimelineStep, LazySbTimelineSteps, LazySbToast, LazySbTooltip, LazySbVideoPlayer, LazySbAccordion, LazySbAccordionItem, LazySbBlogAtAGlance, LazySbBlogGatedChecklist, LazySbBlogLinkCard, LazySbBlogNewsletterButton, LazySbBlogPicture, LazySbBlogPromoGeneral, LazySbBlogQuote, LazySbBlogReadAlso, LazySbBlogUserTestimonial, LazySbButton, LazySbButtonLink, LazySbButtonModal, LazySbButtonScroll, LazySbCard, LazySbCardAuthor, LazySbCardStat, LazySbCarousel, LazySbCarouselItem, LazySbCollage, LazySbCollagePhoto, LazySbEventAgendaListItem, LazySbEventCardAgenda, LazySbFooterItem, LazySbFooterItems, LazySbFormGeneralDynamic, LazySbFormLeadMagnet, LazySbFormSection, LazySbFormWithCalendarTab, LazySbGrid, LazySbGridFlex, LazySbGridItem, LazySbHero, LazySbHeroAbout, LazySbHeroCareers, LazySbHeroDiagnosticEngine, LazySbHeroHomepage, LazySbHeroMedicalKnowledgeBase, LazySbHeroPartnerProgram, LazySbHeroRegional, LazySbHeroReportIssue, LazySbHeroWhitePapers, LazySbBlogpost, LazySbPage, LazySbPageNoHero, LazySbPageWebinar, LazySbPageWithDoubleNavi, LazySbTabWrapper, LazySbThankYouSimple } from '#components'
const lazyGlobalComponents = [
  ["SbAnimatedCounter", LazySbAnimatedCounter],
["SbAudioPlayer", LazySbAudioPlayer],
["SbAudioPlayerNew", LazySbAudioPlayerNew],
["SbBoxWrapper", LazySbBoxWrapper],
["SbBreadcrumbs", LazySbBreadcrumbs],
["SbChartBars", LazySbChartBars],
["SbCircleProgressBar", LazySbCircleProgressBar],
["SbCsSummary", LazySbCsSummary],
["SbCsSummaryItem", LazySbCsSummaryItem],
["SbEventsSection", LazySbEventsSection],
["SbExpertCard", LazySbExpertCard],
["SbFadeCard", LazySbFadeCard],
["SbFeatureCard", LazySbFeatureCard],
["SbFeatureCardLink", LazySbFeatureCardLink],
["SbFilter", LazySbFilter],
["SbGlobalReachGlobe", LazySbGlobalReachGlobe],
["SbGridTwoColumns", LazySbGridTwoColumns],
["SbHiddenSection", LazySbHiddenSection],
["SbHomepageGlobalReach", LazySbHomepageGlobalReach],
["SbIcon", LazySbIcon],
["SbIframeVideo", LazySbIframeVideo],
["SbImageCtaWhitePaper", LazySbImageCtaWhitePaper],
["SbImageWithLabels", LazySbImageWithLabels],
["SbInfiniteMarquee", LazySbInfiniteMarquee],
["SbInfoDepracationSection", LazySbInfoDepracationSection],
["SbInlineVideoPlayer", LazySbInlineVideoPlayer],
["SbInsightsWhitePaper", LazySbInsightsWhitePaper],
["SbLeader", LazySbLeader],
["SbLearnMore", LazySbLearnMore],
["SbLegalItem", LazySbLegalItem],
["SbLegalSection", LazySbLegalSection],
["SbLink", LazySbLink],
["SbLinkWithImage", LazySbLinkWithImage],
["SbListItem", LazySbListItem],
["SbListItemRichtext", LazySbListItemRichtext],
["SbLogotypes", LazySbLogotypes],
["SbMarqueeGeneral", LazySbMarqueeGeneral],
["SbMobileSlider", LazySbMobileSlider],
["SbNews", LazySbNews],
["SbNewsroomFeaturedArticle", LazySbNewsroomFeaturedArticle],
["SbOverlayLabel", LazySbOverlayLabel],
["SbPatientStoryCard", LazySbPatientStoryCard],
["SbPicture", LazySbPicture],
["SbPictureCardImage", LazySbPictureCardImage],
["SbPictureGraph", LazySbPictureGraph],
["SbPictureGridImage", LazySbPictureGridImage],
["SbPictureIcon", LazySbPictureIcon],
["SbPill", LazySbPill],
["SbPortraitsRow", LazySbPortraitsRow],
["SbPostCard", LazySbPostCard],
["SbQuoteAuthor", LazySbQuoteAuthor],
["SbQuoteAuthorNarrow", LazySbQuoteAuthorNarrow],
["SbQuotemarkText", LazySbQuotemarkText],
["SbRectangleLink", LazySbRectangleLink],
["SbResearchStudy", LazySbResearchStudy],
["SbResourcesHubNav", LazySbResourcesHubNav],
["SbReversedPostCard", LazySbReversedPostCard],
["SbRichtext", LazySbRichtext],
["SbRoiCalculator", LazySbRoiCalculator],
["SbSection", LazySbSection],
["SbSectionAnimatedScroll", LazySbSectionAnimatedScroll],
["SbSectionGradient", LazySbSectionGradient],
["SbSeparator", LazySbSeparator],
["SbSimpleText", LazySbSimpleText],
["SbSimpleTwoColumns", LazySbSimpleTwoColumns],
["SbSpacing", LazySbSpacing],
["SbSpacingResponsive", LazySbSpacingResponsive],
["SbStickyItems", LazySbStickyItems],
["SbTable", LazySbTable],
["SbTag", LazySbTag],
["SbTagsGroup", LazySbTagsGroup],
["SbTestCaseTable", LazySbTestCaseTable],
["SbTestimonial", LazySbTestimonial],
["SbTextList", LazySbTextList],
["SbTextWithIcon", LazySbTextWithIcon],
["SbTimelineStep", LazySbTimelineStep],
["SbTimelineSteps", LazySbTimelineSteps],
["SbToast", LazySbToast],
["SbTooltip", LazySbTooltip],
["SbVideoPlayer", LazySbVideoPlayer],
["SbAccordion", LazySbAccordion],
["SbAccordionItem", LazySbAccordionItem],
["SbBlogAtAGlance", LazySbBlogAtAGlance],
["SbBlogGatedChecklist", LazySbBlogGatedChecklist],
["SbBlogLinkCard", LazySbBlogLinkCard],
["SbBlogNewsletterButton", LazySbBlogNewsletterButton],
["SbBlogPicture", LazySbBlogPicture],
["SbBlogPromoGeneral", LazySbBlogPromoGeneral],
["SbBlogQuote", LazySbBlogQuote],
["SbBlogReadAlso", LazySbBlogReadAlso],
["SbBlogUserTestimonial", LazySbBlogUserTestimonial],
["SbButton", LazySbButton],
["SbButtonLink", LazySbButtonLink],
["SbButtonModal", LazySbButtonModal],
["SbButtonScroll", LazySbButtonScroll],
["SbCard", LazySbCard],
["SbCardAuthor", LazySbCardAuthor],
["SbCardStat", LazySbCardStat],
["SbCarousel", LazySbCarousel],
["SbCarouselItem", LazySbCarouselItem],
["SbCollage", LazySbCollage],
["SbCollagePhoto", LazySbCollagePhoto],
["SbEventAgendaListItem", LazySbEventAgendaListItem],
["SbEventCardAgenda", LazySbEventCardAgenda],
["SbFooterItem", LazySbFooterItem],
["SbFooterItems", LazySbFooterItems],
["SbFormGeneralDynamic", LazySbFormGeneralDynamic],
["SbFormLeadMagnet", LazySbFormLeadMagnet],
["SbFormSection", LazySbFormSection],
["SbFormWithCalendarTab", LazySbFormWithCalendarTab],
["SbGrid", LazySbGrid],
["SbGridFlex", LazySbGridFlex],
["SbGridItem", LazySbGridItem],
["SbHero", LazySbHero],
["SbHeroAbout", LazySbHeroAbout],
["SbHeroCareers", LazySbHeroCareers],
["SbHeroDiagnosticEngine", LazySbHeroDiagnosticEngine],
["SbHeroHomepage", LazySbHeroHomepage],
["SbHeroMedicalKnowledgeBase", LazySbHeroMedicalKnowledgeBase],
["SbHeroPartnerProgram", LazySbHeroPartnerProgram],
["SbHeroRegional", LazySbHeroRegional],
["SbHeroReportIssue", LazySbHeroReportIssue],
["SbHeroWhitePapers", LazySbHeroWhitePapers],
["SbBlogpost", LazySbBlogpost],
["SbPage", LazySbPage],
["SbPageNoHero", LazySbPageNoHero],
["SbPageWebinar", LazySbPageWebinar],
["SbPageWithDoubleNavi", LazySbPageWithDoubleNavi],
["SbTabWrapper", LazySbTabWrapper],
["SbThankYouSimple", LazySbThankYouSimple],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
